import utils from 'utils'
import authenticationModalTemplate from '../../../main/common/authenticationModalList.html'
class inputSynProgressCtrl {
    constructor($scope, $timeout, $filter, $uibModalInstance, logger, items1, httpRequest, $uibModal) {
        $scope.returnBtn = false //返回列表
        $scope.stopSynBtn = true //停止同步
        websocketProgress()
        let ws // websocket
        function websocketProgress() {
            httpRequest.post_ivatSocketRequestId({ requestType: 'sync' }).then((res) => {
                let response = res.data.value
                items1.requestId = response
                items1.requestType = '1'
                let isSuccess = false
                httpRequest
                    .post_ivatSyncOvatInvoice(items1)
                    .then((res) => {
                        $scope.taskId = res.data.value
                        isSuccess = true
                    })
                    .finally(() => {
                        isShow(isSuccess)
                    })
                const _path = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host === 'localhost:3000' ? '192.168.52.71' : location.host}/socket/ivatWebsocket/ivatInvoicePool/${response}`
                ws = new WebSocket(_path)
                console.log(ws)
                ws.onopen = function () {
                    console.log(_path)
                    setInterval(function () {
                        ws.send(JSON.stringify({ type: 'heartbeat', timestamp: Date.now() }))
                    }, 5000)
                }
                ws.onerror = function (err) {
                    console.log(err)
                    logger.logError('同步任务因异常原因已中断。')
                    if ($scope.total) {
                        document.getElementById('showTitle').innerText = `您所选的同步范围共包含${$scope.total}条数据。同步任务因异常原因已中断，已同步${$scope.successCount}张发票。`
                    } else {
                        document.getElementById('showTitle').innerText = `您所选的同步范围共包含0条数据。同步任务因异常原因已中断，已同步0张发票。`
                    }
                    ws.close()
                    $scope.stopSynBtn = false //停止同步
                    $scope.returnBtn = true //返回列表
                }
                ws.onmessage = function (evt) {
                    let res = JSON.parse(evt.data)
                    console.log(res)
                    if (res.data.msgCode === 2002 || res.data.msgCode === 2003) {
                        $uibModalInstance.dismiss('cancel')
                        ws.close()
                        let startIndex = res.data.message.length - 11
                        let endIndex = res.data.message.length
                        $uibModal.open({
                            template: authenticationModalTemplate,
                            controller: 'authenticationModalCtrl',
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-lg',
                            resolve: {
                                items1() {
                                    return {
                                        authorizeId: res.data.emsg,
                                        mobile: res.data.message.substring(startIndex, endIndex),
                                    }
                                },
                            },
                        })
                    } else if (res.data.success) {
                        var num = 0
                        $scope.successCount = res.data.value.successCount //已执行成功条数
                        $scope.failCount = res.data.value.failCount //已执行失败条数
                        $scope.realCount = $scope.successCount + $scope.failCount
                        $scope.total = res.data.value.total //总数量条数
                        if ($scope.total === 0) {
                            $scope.stopSynBtn = false //停止同步
                            $scope.returnBtn = true //返回列表
                            document.getElementById('btnText').innerText = `返回列表`
                            document.getElementById('showTitle').innerText = `您所选的同步范围共包含0条数据。同步任务已完成，已同步0张发票。`
                            document.getElementById('content').innerText = `100%`
                            ws.close()
                            return
                        }
                        num = ($scope.realCount / $scope.total) * 700
                        document.getElementById('content').style.width = `${num}px`
                        var num1 = (($scope.realCount / $scope.total) * 100).toFixed(0)
                        document.getElementById('content').innerText = `${num1}%`
                        document.getElementById('showTitle').innerText = `您所选的同步范围共包含${$scope.total}条数据。当前正在同步中，已同步${$scope.realCount}张发票，成功${$scope.successCount}条，失败${$scope.failCount}条。`
                        document.getElementById('btnText').innerText = `停止同步`
                        if (num === 700) {
                            $scope.stopSynBtn = false //停止同步
                            $scope.returnBtn = true //返回列表
                            document.getElementById('btnText').innerText = `返回列表`
                            document.getElementById('showTitle').innerText = `您所选的同步范围共包含${$scope.total}条数据。同步任务已完成，成功${$scope.successCount}条，失败${$scope.failCount}条。`
                            ws.close()
                        }
                    } else {
                        $scope.successCount = res.data.value.successCount //已执行条数
                        $scope.failCount = res.data.value.failCount //已执行失败条数
                        $scope.realCount = $scope.successCount + $scope.failCount
                        $scope.total = res.data.value.total //总数量条数
                        document.getElementById('showTitle').innerText = `您所选的同步范围共包含${$scope.total}条数据。同步任务因异常原因已中断，已同步${$scope.realCount}张发票。`
                        document.getElementById('btnText').innerText = `返回列表`

                        if ($scope.total === 0) {
                            document.getElementById('content').innerText = `100%`
                            return
                        }
                        let num = ($scope.successCount / $scope.total) * 700
                        document.getElementById('content').style.width = `${num}px`
                        let num1 = (($scope.successCount / $scope.total) * 100).toFixed(0)
                        document.getElementById('content').innerText = `${num1}%`

                        ws.close()
                        $scope.stopSynBtn = false //停止同步
                        $scope.returnBtn = true //返回列表
                    }
                }
            })
        }
        // 停止同步
        $scope.stopSyn = function () {
            if ($scope.returnBtn) {
                $uibModalInstance.close($scope.taskId)
            } else {
                if ($scope.total) {
                    document.getElementById('showTitle').innerText = `您所选的同步范围共包含${$scope.total}条数据。任务已暂停，已同步${$scope.successCount}张发票。`
                } else {
                    document.getElementById('showTitle').innerText = `您所选的同步范围共包含0条数据。任务已暂停，已同步0张发票。`
                }
                ws.close()
                httpRequest.get_ivatStopTask($scope.taskId).then((res) => {
                    $scope.stopSynBtn = false //停止同步
                    $scope.returnBtn = true //返回列表
                })
            }
        }
        function isShow(isSuccess) {
            if (!isSuccess) {
                $scope.cancel()
            }
        }
        // 关闭
        $scope.cancel = function () {
            ws.close()
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function (v) {
            ws.close()
            $uibModalInstance.close($scope.taskId)
        }
    }
}

inputSynProgressCtrl.$inject = ['$scope', '$timeout', '$filter', '$uibModalInstance', 'logger', 'items1', 'httpRequest', '$uibModal']
export default inputSynProgressCtrl



// WEBPACK FOOTER //
// ./src/app/input/invoicePool/inputInvoicePool/synProgressCtrl.js